export default ['rgb(0, 142, 198)', 'rgb(216, 127, 38)', 'rgb(107, 95, 158)', 'rgb(40, 128, 124)', 'rgb(148, 159, 177)']